<template>
  <div class="book">
    <div class="middle-main">
      <h2>{{L('付款失敗')}}</h2>
      <!-- <column-title title="付款失敗" desc="" /> -->
      <div class="order-info">
        <div class="info-title justify-between">
          <h2>訂單編號</h2>
          <h2>雜誌名稱</h2>
          <h2>結帳金額</h2>
        </div>
        <div
          class="info-con justify-between"
          v-for="item in orderItem"
          :key="item.goodsId"
        >
          <h2># {{ item.orderNo }}</h2>
          <h2>{{ item.title }}</h2>
          <h2>HK$ {{ item.payment }}</h2>
        </div>
        <h1>使用「信用卡付款」的顧客：</h1>
        <p>
          您的商品將於7~16個工作天完成出貨。
          若您購買的商品為限量商品且已售完，客服人員將與您聯繫，取消該商品訂單並退還款項。
        </p>
        <h1>使用「匯款付款」的顧客：</h1>
        <p>
          匯款後煩請告知匯款帳號後五碼，確認收到您的款項後，商品將於7~16個工作天完成出貨。
          若您購買的商品為限量商品且已售完，客服人員將與您聯繫，取消該商品訂單並退還款項。
        </p>
        <h1>客服專線</h1>
        <p>週一至週五 : 上午9:00 - 12:00 - 下午1:00 - 5:30 E-MAIL: taishang960@sina.com</p>
        <!-- <el-row :gutter="16" class="btns">
          <el-col :span="12"><div class="btn">回首頁</div></el-col>
          <el-col :span="12">
            <div class="btn bg-red text-white">重新付款</div>
          </el-col>
        </el-row> -->
      </div>
    </div>
    <div class="main other-news">
      
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import swiperPolicy from "../common/swiper-policy.vue";
import ColumnTitle from "../common/column-title.vue";
import { orderDetails } from "@/assets/api/magazine.js";

export default {
  components: {
    swiperPolicy,
    ColumnTitle,
  },
  data() {
    return {
      orderItem: {},
    };
  },
  created() {
    orderDetails(this.$route.query.orderNo).then((res) => {
      console.log(res);
      this.orderItem = res.data.data.rows;
    });
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>

<style  lang="less" scoped>
.book {
  padding-top: 57px;
  h2 {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 32px;
    color: #2C2C2E;
    line-height: 42px;
    text-align: left;
    font-style: normal;
    margin-bottom: 40px;
  }
  .order-info {
    // width: 614px;
    margin: auto;
    .info-title {
      padding: 13px 0;
      border-bottom: 1px solid #e1e1e1;
      h2 {
        font-family: NotoSansCJKTC;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.29;
        letter-spacing: 4.2px;
        text-align: left;
        color: #010101;
      }
    }
    .info-con {
      padding: 23px 0;
      h2 {
        font-family: NotoSansCJKTC;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.03;
        letter-spacing: normal;
        color: #000;
      }
    }
    h1 {
      font-family: NotoSansCJKTC;
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: 9.6px;
      text-align: left;
      color: #e13133;
      margin-top: 46px;
      margin-bottom: 20px;
    }
    p {
      font-family: NotoSansCJKTC;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: 1.8px;
      text-align: left;
      color: #959595;
    }
    .btns {
      margin-top: 70px;
    }
    .btn {
      padding: 15px 0;
      border-radius: 8px;
      border: solid 1px #e13133;
      font-family: NotoSansCJKTC;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: 4.2px;
      text-align: center;
      color: #e13133;
      cursor: pointer;
    }
  }
}

.other-news {
  padding: 40px 0 80px;
  margin-top: 100px;
}
@media screen and (max-width: 768px) {
  .book {
    padding-top: 0;
    .order-info {
      padding: 0 20px;
      width: 100%;
    }
  }
  .other-news {
    padding: 40px 0 80px;
    margin-top: 0;
  }
}
</style>
<style>
</style>



// WEBPACK FOOTER //
// src/views/magazine-fail/index.vue